import { eventConstants } from "../_constants";

const iniState = {
  loading:true,
  customertierlist:null,
  error:""
}
export function customertierlist(state = {}, action) {
  switch (action.type) {
    case eventConstants.CUSTOMER_TIER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case eventConstants.CUSTOMER_TIER_LIST_SUCCESS:
      return {
        ...state,
        loading:false,
        customertierlist: action.customertierlist,
        error: "",
      };
    case eventConstants.CUSTOMER_TIER_LIST_FAILURE:
      return {
        ...state,
        loading:false,
        error: action.error,
      };

    
    default:
      return state;
  }
}